export default {
  JobLocation: '#{neighborhood}, #{city}',
  PayAndHours: {
    Title: 'Pay & Hours',
    Shifts: 'Based on #{numShifts} day(s)/week',
    Flexible: 'Flexible schedule',
    HourlyRate: 'Hourly rate',
    PerWeek: 'Per week',
    EstimatedEarnings: 'Estimated Earnings',
  },
  Location: {
    Title: 'Location',
    Content: '#{neighborhood}, #{city}',
  },
  RequiredDays: {
    Title: 'Required Days',
    LiveIn: '7 days a week, 8 hours a day',
    Flexible: 'Flexible schedule',
    PreferredDays: 'Preferred days: #{value}',
    PreferredTimes: 'Preferred times: #{value}',
    VisitDuration: 'Visit duration: #{value}',
    AnyDay: 'Any day',
    AnyTime: 'Any time',
    Morning: 'Morning',
    Afternoon: 'Afternoon',
    Evening: 'Evening',
    Overnight: 'Overnight',
    Sun: 'Sun',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
  },
  Description: 'Description',
  AdditionalConsiderations: 'Additional Considerations',
  CarePlan: {
    Title: 'Care needs',
    Options: {
      MOBILITY_SUPPORT: {
        Label: 'Mobility support',
        Description: 'Help with walking, transfers, or getting around',
      },
      MEDICATION_REMINDERS: {
        Label: 'Medication reminders',
        Description: 'Ensuring medications are taken on time',
      },
      MEAL_PREP: {
        Label: 'Meal prep',
        Description: 'Preparing nutritious meals and snacks',
      },
      LIGHT_HOUSEKEEPING: {
        Label: 'Light housekeeping',
        Description: 'Basic cleaning and tidying up',
      },
      TRANSPORTATION: {
        Label: 'Transportation',
        Description: 'Driving to appointments and errands',
      },
      COMPANIONSHIP: {
        Label: 'Companionship',
        Description: 'Social interaction and emotional support',
      },
      PERSONAL_CARE: {
        Label: 'Personal care',
        Description: 'Assistance with bathing, grooming, and dressing',
      },
      MEDICAL_APPOINTMENTS: {
        Label: 'Medical appointments',
        Description: 'Accompanying to and from medical visits',
      },
      SHOPPING_ASSISTANCE: {
        Label: 'Shopping assistance',
        Description: 'Help with grocery shopping and errands',
      },
      PET_CARE: {
        Label: 'Pet care',
        Description: 'Feeding, walking, and caring for pets',
      },
    },
  },
  StartDate: {
    Title: 'Expected start date',
    Options: {
      IMMEDIATELY: {
        Label: 'Immediately',
        Description: 'Ready to start right away',
      },
      ONEWEEK: {
        Label: 'Within 1 week',
        Description: 'Can begin in the next few days',
      },
      TWOWEEK: {
        Label: 'Within 2 weeks',
        Description: 'Need a bit more time to prepare',
      },
      ONEMONTH: {
        Label: 'Within 1 month',
        Description: 'Flexible timing, no rush',
      },
      TWOMONTH: {
        Label: 'Within 2 months',
        Description: 'Planning ahead for future needs',
      },
      FLEXIBLE: {
        Label: 'Flexible timing',
        Description: 'Open to discussing the best start date',
      },
    },
  },
  Requirements: {
    Title: 'Requirements',
    LicenseCertification: 'License/Certification',
    RequiredLanguages: 'Required languages',
    Considerations: 'Considerations',
    CertificationsOptions: {
      PSW: 'Personal Support Worker (PSW)',
      DSW: 'Developmental Service Worker (DSW)',
      PAB: 'Préposé aux bénéficiaires (PAB)',
      CNA: 'Certified Nursing Assistant (CNA)',
      HCA: 'Health Care Aide (HCA)',
      RNA: 'Registered Nursing Assistant (RNA)',
      RPN: 'Registered Practical Nurse (RPN)',
      RN: 'Registered Nurse (RN)',
      CPR: 'CPR Certification',
      FIRST_AID: 'First Aid Certification',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
    },
    CertificationsOptionsShort: {
      PSW: 'PSW',
      DSW: 'DSW',
      PAB: 'Préposé aux bénéficiaires',
      CNA: 'Certified Nursing Assistant',
      HCA: 'Health Care Aide',
      RNA: 'Registered Nursing Assistant',
      RPN: 'Registered Practical Nurse',
      RN: 'Registered Nurse',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
      UNACCREDITED: 'Caregiving Companion',
    },
    CertificationsOptionsTitle: {
      PSW: 'Personal Support Worker',
      DSW: 'Developmental Support Worker',
      RN: 'Registered Nurse',
      PAB: 'Préposé aux bénéficiaires',
      CNA: 'Certified Nursing Assistant',
      RPN: 'Registered Practical Nurse',
      RNA: 'Registered Nursing Assistant',
      HCA: 'Health Care Aide',
      PSW_STUDENT: 'Personal Support Worker Student',
      NURSING_STUDENT: 'Nursing Student',
      CSW: 'Community Service Worker',
      SSW: 'Social Service Worker',
      UNACCREDITED: 'Caregiving Companion',
    },
    LanguageOptions: {
      ENGLISH: 'English',
      FRENCH: 'French',
      CHINESE: 'Chinese',
      HINDUSTANI: 'Hindustani',
      SPANISH: 'Spanish',
      PUNJABI: 'Punjabi',
      ARABIC: 'Arabic',
      TAGALOG: 'Tagalog',
      ITALIAN: 'Italian',
      GERMAN: 'German',
      PORTUGUESE: 'Portuguese',
      PERSIAN: 'Persian',
      RUSSIAN: 'Russian',
      TAMIL: 'Tamil',
      VIETNAMESE: 'Vietnamese',
      GUJARATI: 'Gujarati',
      POLISH: 'Polish',
      KOREAN: 'Korean',
      SERBO_CROATIAN: 'Serbo-Croatian',
      GREEK: 'Greek',
      HAITIAN_CREOLE: 'Haitian Creole',
      UKRAINIAN: 'Ukrainian',
      BENGALI: 'Bengali',
      ROMANIAN: 'Romanian',
      DUTCH: 'Dutch',
      CREE: 'Cree',
      JAPANESE: 'Japanese',
      HEBREW: 'Hebrew',
      TURKISH: 'Turkish',
      MALAYALAM: 'Malayalam',
      LITHUANIAN: 'Lithuanian',
      ILOCANO: 'Ilocano',
      SOMALI: 'Somali',
      SWAHILI: 'Swahili',
      TELUGU: 'Telugu',
      MANDARIN: 'Mandarin',
      CANTONESE: 'Cantonese',
      HINDI: 'Hindi',
    },
    ConsiderationsOptions: {
      COMFORTABLE_WITH_PETS: 'Comfortable working around pets',
      COMFORTABLE_WITH_STAIRS: 'Comfortable with stairs',
      NON_SMOKING_HOUSEHOLD: 'Non-smoking household preferred',
      PHYSICAL_LIFTING_REQUIRED: 'Physical lifting may be required',
      DEMENTIA_ALZHEIMER_EXPERIENCE: 'Experience with dementia/Alzheimer\'s',
      FLEXIBLE_SCHEDULE_CHANGES: 'Flexible with schedule changes',
    },
  },
  ApplyButton: {
    Title: 'Apply for this position',
    ClickHere: 'Click here to submit your application for this role.',
    TakenTo: 'You’ll be taken to the application page.',
  },
};
